<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Liste des candidatures à une formation">
        <v-row>
          <v-col cols="12">
            <v-select
              v-show="multiCampus"
              v-model="idCampusSelect"
              label="Campus"
              :items="campus"
              item-value="id"
              item-text="libelle"
              @change="getFormations(true)"
            >
            </v-select>
            <v-combobox
              v-model="select"
              :items="items"
              :item-text="displayItem"
              item-value="id"
              @change="getCandidatures"
              label="Sélectionnez une formation"
            ></v-combobox>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="candidatures"
              hide-default-footer
              disable-pagination
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              item-key="id"
              class="elevation-1"
              :custom-sort="customSort"
              :search="search"
            >
              <template v-slot:[`item.uid`]="{ item }">
                <v-icon v-if="item.uid" :color="colorUnivLille"
                  >mdi-alpha-l-circle</v-icon
                >
              </template>
              <template v-slot:[`item.nom`]="{ item }">
                <v-tooltip
                  v-if="item.uid"
                  bottom
                  max-width="20%"
                  :color="colorUnivLille"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">{{ item.nom }}</span>
                  </template>
                  <span>Étudiant interne</span>
                </v-tooltip>
                <v-tooltip v-else bottom max-width="20%">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">{{ item.nom }}</span>
                  </template>
                  <span>Étudiant externe</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.etatDemande`]="{ item }">
                {{ item.etatDemande.libelle }}
                <span
                  v-if="
                    item.etatDemande.id == ETAT.ACCEPTEE.code ||
                    item.etatDemande.id == ETAT.REFUSEE.code ||
                    item.etatDemande.id == ETAT.NON_VALIDE.code ||
                    item.etatDemande.id == ETAT.TRAITEMENT_PEDAGOGIQUE.code
                  "
                >
                  le {{ item.dateDecision }}</span
                >
                <span
                  v-if="
                    item.etatDemande.id == ETAT.CONFIRMEE.code ||
                    item.etatDemande.id == ETAT.DESISTEMENT.code ||
                    item.etatDemande.id == ETAT.ABANDON.code
                  "
                >
                  le {{ item.dateConfirmation }}</span
                >
                <span v-if="item.etatDemande.id == ETAT.FINALISEE.code">
                  le {{ item.dateFinalisation }}</span
                >
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <router-link
                  :to="{
                    name: 'candidature-suaio',
                    params: {
                      idCandidature: item.id,
                      idFormation: select.id,
                      idCampus: idCampusSelect,
                    },
                  }"
                >
                  <v-icon
                    v-if="item.etatDemande.id == ETAT.VALIDATION_SUAIO.code"
                    class="mr-2"
                    title="Examiner la candidature"
                    >mdi-pencil</v-icon
                  >
                  <v-icon v-else class="mr-2" title="Visualiser la candidature"
                    >mdi-eye</v-icon
                  ></router-link
                >
              </template>
              <template v-slot:top>
                <v-row>
                  <v-select
                    v-model="etatFiltre"
                    label="Filtre état demande"
                    :items="etatDemandes"
                    item-value="id"
                    item-text="libelle"
                    class="mx-5"
                  >
                  </v-select>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Recherche"
                    single-line
                    hide-details
                    class="mx-5"
                  ></v-text-field>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import { EtatDemande } from "@/mixins/EtatDemande.js";
import ListingSort from "@/js_modules/ListingSort";
import ApiCandidatureRepository from "@/repositories/ApiCandidatureRepository";
import ApiFormationRepository from "@/repositories/ApiFormationRepository";
import ApiCampusRepository from "@/repositories/ApiCampusRepository";
import { mapState } from "vuex";

export default {
  name: "ListeCandidaturesSuaio",
  components: { BaseBlock },
  props: ["idFormation", "idCampus"],
  mixins: [EtatDemande],
  data() {
    return {
      select: [],
      items: [],
      idCampusSelect: "",
      campus: [],
      search: "",
      candidatures: [],
      etatFiltre: "",
      etatDemandes: [
        { id: null, libelle: "" },
        { id: 2, libelle: "en attente validation SUAIO" },
        { id: 3, libelle: "en attente d'examen" },
        { id: 4, libelle: "demande acceptée" },
        { id: 5, libelle: "demande refusée" },
        { id: 6, libelle: "demande non valide" },
        { id: 8, libelle: "demande confirmée" },
        { id: 9, libelle: "désistement" },
        { id: 10, libelle: "demande abandonnée" },
        { id: 11, libelle: "demande finalisée" },
      ],
      sortBy: "dateDepot",
      sortDesc: true,
      colorUnivLille: "#1f8388",
    };
  },
  watch: {
    etatFiltre(id) {
      sessionStorage.lcsEtatFiltre = id;
    },
  },
  async created() {
    if (sessionStorage.lcsEtatFiltre) {
      if (sessionStorage.lcsEtatFiltre != 0) {
        this.etatFiltre = parseInt(sessionStorage.lcsEtatFiltre);
      }
    }
    this.getCampus();
  },
  methods: {
    displayItem(item) {
      let nbCandidaturesATraiter = item.nbCandTrait;
      if (nbCandidaturesATraiter > 0) {
        return item.libelle + " (" + nbCandidaturesATraiter + ")";
      } else {
        return item.libelle;
      }
    },
    customSort: function (items, index, isDesc) {
      return ListingSort.sortColumns(items, index, isDesc);
    },

    async getCampus() {
      try {
        const campus = await ApiCampusRepository.getCampusSUAIO();
        this.campus = campus;

        if (this.idCampus && this.idCampus != ":idCampus") {
          let campus = this.campus.find((x) => x.id == this.idCampus);
          this.idCampusSelect = campus.id;
        } else {
          this.idCampusSelect = this.campus[0].id;
        }

        //this.idCampus = this.campus[0].id;
        this.getFormations();
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async getFormations(reinit) {
      try {
        this.candidatures = [];
        const formations = await ApiFormationRepository.getFormationsSUAIO(
          this.idCampusSelect
        );
        this.items = formations;

        if (!reinit && this.idFormation && this.idFormation != ":idFormation") {
          this.select = this.items.find((x) => x.id == this.idFormation);
        } else {
          this.select = this.items[0];
          this.sortBy = "dateDepot";
          this.sortDesc = true;
        }
        this.getCandidatures();
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async getCandidatures() {
      if (this.select !== undefined && this.select.id !== undefined) {
        try {
          const candidatures = await ApiCandidatureRepository.getCandidatures(
            this.select.id
          );
          this.candidatures = candidatures;
        } catch (error) {
          this.$toast.error(error.response.data.messages[0]);
        }
      }
    },
  },
  computed: {
    ...mapState(["user"]),
    multiCampus() {
      return this.campus.length > 1;
    },
    headers() {
      return [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "uid",
        },
        {
          text: "Nom",
          align: "left",
          sortable: true,
          value: "nom",
        },
        {
          text: "Prénom",
          align: "left",
          sortable: true,
          value: "prenom",
        },
        {
          text: "Date de naissance",
          align: "center",
          sortable: true,
          value: "dateNaissance",
        },
        {
          text: "Date de dépôt",
          align: "center",
          sortable: true,
          value: "dateDepot",
        },
        {
          text: "Etat de la demande",
          align: "center",
          sortable: true,
          value: "etatDemande",
          filter: (value) => {
            if (!this.etatFiltre) return true;
            return value.id == parseInt(this.etatFiltre);
          },
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
          value: "action",
        },
      ];
    },
  },
};
</script>
